import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { AccountApiService } from '../../../core/services/account-api.service';
import { InputTextComponent } from '../../../shared/components/input-text/input-text.component';
import { InputSelectComponent } from '../../../shared/components/input-select/input-select.component';
import { DialogModule } from 'primeng/dialog';
import { FormGroup, FormControl, Validators, FormsModule } from '@angular/forms';
import { SelectInput } from '../../../shared/interfaces/select-input';
import { Account } from '../../../core/interfaces/account';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { InputIcon } from 'primeng/inputicon';
import { ToolbarModule } from 'primeng/toolbar';
import { IconField } from 'primeng/iconfield';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { BooleanToActive } from '../../../shared/pipes/boolean-to-active';
import { FieldsetModule } from 'primeng/fieldset';
import { InputMaskComponent } from "../../../shared/components/input-mask/input-mask.component";

@Component({
  selector: 'app-account',
  imports: [ButtonModule,
    TableModule,
    InputTextComponent,
    DialogModule,
    ToastModule,
    InputIcon,
    ToolbarModule,
    IconField,
    FormsModule,
    InputTextModule,
    BooleanToActive,
    InputSelectComponent,
    BlockUIModule,
    ProgressSpinnerModule,
    FieldsetModule, InputMaskComponent],
  templateUrl: './account.component.html',
  styleUrl: './account.component.scss',
  providers: []
})
export class AccountComponent implements OnInit {

  blockedDocument: boolean = false;
  accounts!: Account[]
  visible = false;
  editVisible = false;  
  name!: string;
  statusOptions: SelectInput[] = [   
    {label: 'Active',
     code: true},
    {label: 'Suspended',
     code: false},]


  accountForm = new FormGroup({
      name: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
      active: new FormControl<boolean | undefined>(undefined, Validators.required,),
      accountHolder: new FormGroup({  
        name: new FormControl<string | undefined>(undefined, [Validators.required, Validators.maxLength(50)]), 
        title: new FormControl<string | undefined>(undefined, [Validators.required, Validators.maxLength(50)]), 
        businessAddress: new FormControl<string | undefined>(undefined, [Validators.required, Validators.maxLength(50)]), 
        email: new FormControl<string | undefined>(undefined, [Validators.required, Validators.email, Validators.maxLength(50)]),
        businessPhone: new FormControl<string | undefined>(undefined, [Validators.required, Validators.maxLength(50), Validators.pattern('^[- +()0-9]+$')]) ,
        mobilePhone: new FormControl<string | undefined>(undefined, [Validators.required, Validators.maxLength(50), Validators.pattern('^[- +()0-9]+$')]) 
      })
  });

  editAccountForm = new FormGroup({
      name: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
      id: new FormControl<string | undefined>('', Validators.required,),
      active: new FormControl<boolean | undefined>(undefined, Validators.required,),
      accountHolder: new FormGroup({  
        name: new FormControl<string | undefined>(undefined, [Validators.required, Validators.maxLength(50)]), 
        id: new FormControl<string | undefined>(undefined,),         
        title: new FormControl<string | undefined>(undefined, [Validators.required, Validators.maxLength(50)]), 
        businessAddress: new FormControl<string | undefined>(undefined,[Validators.required, Validators.maxLength(50)]), 
        email: new FormControl<string | undefined>(undefined, [Validators.required, Validators.maxLength(50)]),
        businessPhone: new FormControl<string | undefined>(undefined, [Validators.required, Validators.maxLength(50), Validators.pattern('^[- +()0-9]+$')]) ,
        mobilePhone: new FormControl<string | undefined>(undefined, [Validators.required, Validators.maxLength(50), Validators.pattern('^[- +()0-9]+$')]) 
      })
  });

  constructor(private accountApi: AccountApiService, private messageService: MessageService) {
   

  }

  ngOnInit(): void {
     this.loadAccounts();
  }

  loadData() {
    this.accountForm = new FormGroup({
          name: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
          active: new FormControl<boolean | undefined>(undefined, Validators.required,),
          accountHolder: new FormGroup({  
            name: new FormControl<string | undefined>(undefined, [Validators.required, Validators.maxLength(50)]), 
            title: new FormControl<string | undefined>(undefined, [Validators.required, Validators.maxLength(50)]), 
            businessAddress: new FormControl<string | undefined>(undefined, [Validators.required, Validators.maxLength(50)]), 
            email: new FormControl<string | undefined>(undefined, [Validators.required, Validators.email, Validators.maxLength(50)]),
            businessPhone: new FormControl<string | undefined>(undefined, [Validators.required, Validators.maxLength(50), Validators.pattern('^[- +()0-9]+$')]) ,
            mobilePhone: new FormControl<string | undefined>(undefined, [Validators.required, Validators.maxLength(50), Validators.pattern('^[- +()0-9]+$')]) 
          })
      });

  }

  loadAccounts() {
    this.accountApi.getAccounts().subscribe({
        next: (data) =>{
          this.accounts = data
          this.visible = false;
        } ,
        error: (err) => {
          console.error('Error fetching data', err)
          this.messageService.add({ severity: 'error', summary: 'Error', detail: "It wasn't possible to retrieve accounts.", life: 5000 })

        }

    })
  }

  save() {

    if (this.accountForm.valid) {
     const account: Account = this.accountForm.value
     this.blockedDocument = true;
     this.accountApi.createAccount(this.accountForm.value).subscribe({
        next: (data) =>{
          this.blockedDocument = false;
          this.messageService.add({ severity: 'info', summary: 'Success', detail: 'Account succesfully saved.' })
          this.loadAccounts();
          this.visible = false;

        } ,
        error: (err) => {
          this.blockedDocument = false;
          let errorMessage = "It wasn't possible to save the account." ;
          if (err.error && err.error.message) {
                errorMessage += err.error.message;
          }

          this.messageService.add({ severity: 'error', summary: 'Error', 
                        detail: errorMessage, life: 5000})          

        }
     })
    } else {
        this.accountForm.markAllAsTouched()
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please, verify the required fields.', life: 5000 })

    }

  }

  showDialog() {
      this.visible = true;
  }

  showEditAccount(account: Account) {
    this.editVisible = true
    this.editAccountForm.patchValue(account)
  }

  updateSubscription() {
    if (this.editAccountForm.valid) {
     const account: Account = this.editAccountForm.value
     this.blockedDocument = true;
     this.accountApi.updateAccount(account.id!, account).subscribe({
        next: (data) =>{
          this.blockedDocument = false;
          this.messageService.add({ severity: 'info', summary: 'Success', detail: 'Account succesfully saved.' })
          this.loadAccounts();
          this.editVisible = false;

        } ,
        error: (err) => {
          this.blockedDocument = false;
          let errorMessage = "It wasn't possible to update the account." ;
          if (err.error && err.error.message) {
                errorMessage += err.error.message;
          }

          this.messageService.add({ severity: 'error', summary: 'Error', 
                        detail: errorMessage, life: 5000})        
        }
     })
    } else {
        this.editAccountForm.markAllAsTouched();
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please, verify the required fields.', life: 5000 })

    }    
  }

  get filteredItems() {
    if(this.accounts) {
          return this.accounts.filter(item =>
            (!this.name || item!.name!.toLowerCase().includes(this.name.toLowerCase())) 
    ); }
    return [];
  }

}
